<template>
   <header id="user_header">
      <div class="us_wrap">
          <h1 id="logo" @click="$router.push('/')">
             <img src="@/assets/img/layout/user_logo.svg" alt="Admin Logo">
          </h1>
          <div class="gnb">
             <ul>
                <li v-for="( item, index ) in gnbData" :key="index">
                   <router-link :to="item.path" class="dp1">{{ item.name }}</router-link>
                   <ul class="dp2">
                      <li v-for=" ( item2, index2 ) in item.children " :key="index2">
                         <router-link :to="item2.path">{{ item2.name }}</router-link>
                         <!-- <a href="javascript:void(0);">{{ item2.name }}</a> -->
                      </li>
                   </ul>
                </li>
             </ul>
         </div>

          <div class="gnb_item">
            <div class="btn_wrap" v-if="!isLogin">
               <router-link
               v-if="!isLogin" 
               to="/login" 
               class="login_btn">
                  로그인
              </router-link> | 
               <router-link to="/userJoin" class="login_btn">
                  회원가입
               </router-link>
            </div>
            <div class="login_after" v-else>
               <button @click="fn_loginInfo_show">{{nickNm}} 님</button>
               <button @click="fn_log_out">로그아웃</button>
               
               <div class="user_info_box" v-show="hover">
                  <div class="user">
                    <p>
                        <strong v-if="clinicNm != ''"> {{clinicNm}}</strong>
                        <img :src="require('@/assets/img/icon/licorice.png')" class="icon"/> {{nickNm}} 님
                     </p>
                     <b-icon icon="x" @click="hover = false"></b-icon>
                  </div>
                  <ul class="point_box">
                     <li>
                        <p>예치금</p>
                        <p>100,000 <span>원</span></p>
                     </li>
                     <li>
                        <p>포인트</p>
                        <p>100,000 <span>POINT</span></p>
                     </li>
                  </ul>
                  <div class="info_box">
                     <router-link to="/">예치금 내역</router-link>
                     <router-link to="/mypage/myInfo">회원 정보</router-link>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </header>

</template>

<script>
   import { gnbData } from "@/data/user/GnbMenuList"
   export default {
      name: "UserGnb",
      data () {
            return { 
               loginId : '',
               doctorNm : '',
               clinicNm : '',
               nickNm : ''

            }
      },      
      // computed(){
      //    let loginchk= this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

      //    if(loginchk != ''){
      //       this.isLogin = true;
      //    }
      // },
      created(){
         
         this.loginId = this.$store.getters['clinicDoctorInfo/getLoginId'];

         console.log("@@@@@ loginId  : %o",this.loginId);

         if(this.loginId != ''){
            this.isLogin = true;
            this.doctorNm = this.$store.getters['clinicDoctorInfo/getDoctorNm'];
            this.clinicNm = this.$store.getters['clinicDoctorInfo/getClinicNm'];
            this.nickNm = this.$store.getters['clinicDoctorInfo/getNickNm'];
         }
      },
      mounted(){
         
      },
      data() {
         return {
            isLogin : false,
            hover: false,
            gnbData: gnbData,
         }
      },
      methods : {         
         fn_log_out(){
            this.isLogin = false;
            this.$store.dispatch('clinicDoctorInfo/setClinicDoctorInfoInit'); 
            this.$store.dispatch('commonStore/setCommonStoreInit'); 
            this.$store.dispatch('detailSearchInfo/setDetailSearchInfoInit');
            this.$router.push({ name: 'Main'});        
         },
         fn_loginInfo_show(){
            this.hover = true;
         }
      }
   }
</script>